import * as React from 'react';
import { SVGProps } from 'react';
const SvgSearch = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.5351 16.4045C13.2375 17.3288 11.6504 17.8732 9.9354 17.8732C5.55319 17.8732 2 14.3195 2 9.9366C2 5.55373 5.55319 2 9.9354 2C14.3176 2 17.8708 5.55373 17.8708 9.9366C17.8708 11.6518 17.3265 13.2392 16.4023 14.537L22 20.1355L20 21.8683L14.5361 16.4035L14.5351 16.4045ZM9.9354 16.0058C13.2869 16.0058 16.0036 13.2886 16.0036 9.9366C16.0036 6.58455 13.2869 3.86744 9.9354 3.86744C6.58386 3.86744 3.86715 6.58455 3.86715 9.9366C3.86715 13.2886 6.58386 16.0058 9.9354 16.0058Z"
      fill="current"
    />
  </svg>
);
export default SvgSearch;
